<div
  [class.error-label]="type === MessageType.ERROR"
  [class.success-label]="type === MessageType.SUCCESS"
  *ngIf="type !== MessageType.NONE"
>
  <fa-icon [icon]="type === MessageType.ERROR ? faTimes : faCheck"></fa-icon>
  {{message}}
  <ng-content></ng-content>
</div>
